import React from 'react'
import Head from 'next/head'
import { validateCanonical } from '@utils/validate-canonical-url'
import { useRouter } from 'next/router'

interface SEOProps {
  title: string
  titlePrefix?: boolean
  description: string
  coverImage?: string
  shouldIndexPage?: boolean
  canonicalUrl?: string
  twitter?: string
  type?: string
  siteName?: string
  modifiedTime?: string
  publishedTime?: string
  url?: string
  width?: number
  height?: number
}

const SEO: React.FC<SEOProps> = ({
  title,
  titlePrefix = false,
  description,
  coverImage,
  shouldIndexPage = true,
  canonicalUrl,
  twitter,
  type = 'article',
  siteName = 'Portal Solar – Primeiro e maior portal de energia solar do Brasil',
  modifiedTime = null,
  publishedTime = null,
  width = 1200,
  height = 630,
  url
}) => {
  const router = useRouter()
  const currentUrl =
    url || `${process.env.NEXT_PUBLIC_URL_BASE}${router.asPath}`

  if (titlePrefix) {
    title = `${title} | ${siteName}`
  }
  return (
    <Head>
      <title>{title}</title>

      {description && <meta name="description" content={description} />}
      <link
        rel="canonical"
        href={validateCanonical(canonicalUrl, router.asPath)}
      />
      <meta
        name="robots"
        content={shouldIndexPage ? 'index, follow' : 'noindex, nofollow'}
      />

      <meta httpEquiv="x-ua-compatible" content="IE=edge,chrome=1" />
      <meta name="MobileOptimized" content="320" />
      <meta name="HandheldFriendly" content="True" />

      <meta name="theme-color" content="#FFF" />
      <meta name="msapplication-TileColor" content="#FFF" />
      <meta name="referrer" content="no-referrer-when-downgrade" />

      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />

      {coverImage && (
        <meta name="image" property="og:image" content={coverImage} />
      )}
      {coverImage && (
        <meta property="og:image:secure_url" content={coverImage} />
      )}
      <meta property="og:image:alt" content="Thumbnail" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content={`${width}`} />
      <meta property="og:image:height" content={`${height}`} />

      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}

      {modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}

      <meta name="twitter:title" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      {twitter && <meta name="twitter:creator" content={twitter} />}
      {coverImage && <meta name="twitter:image" content={coverImage} />}
      {coverImage && <meta name="twitter:image:src" content={coverImage} />}
      <meta name="twitter:image:alt" content="Thumbnail" />
      <meta name="twitter:image:width" content="1200" />
      <meta name="twitter:image:height" content="620" />
    </Head>
  )
}

export default SEO
